// Import 3rd-party dependencies
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SubSink } from 'subsink';

// Import project-specific dependencies
import { RECENT_SEARCH_SERVICE_CONSTS } from '@app/config/constants';
import { IRecents, UserProfileService } from '@app/services/user-profile/user-profile.service';

@Injectable({
  providedIn: 'root'
})
export class RecentSearchService {
  private subs: SubSink;
  private searches: string[];
  private searchesSubject = new Subject<string[]>();
  searches$ = this.searchesSubject.asObservable();
  consts = RECENT_SEARCH_SERVICE_CONSTS;

  constructor(private userProfileService: UserProfileService) {
    this.searches = [];
    this.subs = new SubSink();
  }

  getRecents(): void {
    this.subs.sink = this.userProfileService.recents$
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.status === 404) {
            return this.userProfileService.saveSearches([]).pipe(switchMap(() => of({ searches: [] } as IRecents)));
          } else {
            return of({ searches: [] } as IRecents);
          }
        }),
        map((res) => res.searches.slice(0, this.consts.MAXIMUM_RECENT_SEARCH_LENGTH))
      )
      .subscribe((searches) => {
        this.searches = [...new Set(searches)];
        this.searchesSubject.next(this.searches);
      });
  }

  addRecentSearch(search: string): void {
    if (!this.searches.includes(search)) {
      this.searches.unshift(search) > this.consts.MAXIMUM_RECENT_SEARCH_LENGTH ? this.searches.pop() : null;
      this.searchesSubject.next(this.searches);
      this.subs.sink = this.userProfileService.updateSearches(this.searches).subscribe();
    }
  }
}
